import React, { useEffect, useMemo, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import {
  formatAmount,
  formatTenure,
  getIcdRequestStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"
import { useLazyGetInvestmentSchedulesQuery } from "store/api/investors/reports.api"

const defaultFilters = {
  search: "",
  page: 1,
  created_by: "INVESTOR",
  pageSize: 20,
  timestamp: "",
}

const InvestmentSchedule = () => {
  const [getResults, { isFetching }] = useLazyGetInvestmentSchedulesQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)

  //meta title
  document.title = "Investment Schedules - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(() => [
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Reference No."),
      accessorKey: "unique_code",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-number">{row?.original.unique_code}</div>
      ),
    },
    {
      header: ({ column }) =>
        // getTableSortingHeaderIcon(column, "Scheduled Date"),
        getTableSortingHeaderIcon(column, "Date of Investment"),
      accessorKey: "approved_at",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>{moment(row?.original.approved_at).format("D MMM YYYY")}</>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Amount (₹)"),
      accessorKey: "amount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <div>₹ {formatAmount(row?.original.amount)}</div>,
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Interest"),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{row?.original.interest_rate} %</div>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Date of Repayment"),
      accessorKey: "repayment_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">
          {row?.original.repayment_date
            ? moment(row?.original.repayment_date).format("D MMM YYYY")
            : ""}
        </div>
      ),
    },
    {
      header: () => <div className="flex items-center gap-2">Status</div>,
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }) => (
        <div className="code-status">
          {getIcdRequestStatus(row?.original.status)}
        </div>
      ),
    },
  ])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Investment Schedules"} breadcrumbItem={"ICDs"} />
          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            // isGlobalFilter={true}
            isCustomPageSize={false}
            // isGlobalFilter={true}
            isPagination={false}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvestmentSchedule
